import React from 'react'
import * as UI from '@/components/UI'
import { Section, Cell, BlockQuote } from './QuoteSlice.css'

const QuoteSlice = ({ primary }) => {
  const html = primary?.text?.html
  if (!html) return null
  return (
    <Section>
      <UI.Container>
        <UI.Grid>
          <Cell>
            <BlockQuote dangerouslySetInnerHTML={{ __html: html }} />
          </Cell>
        </UI.Grid>
      </UI.Container>
    </Section>
  )
}

export default QuoteSlice
